import { useMemo } from 'react'
import {
  FormControl,
  FormLabel,
  HStack,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Stack,
  Text,
} from '@chakra-ui/react'
import { Controller, UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import { convertBytesNumberToString } from 'utils/transforms/number'

// import Validation from './components/Validation'

type KeyString = {
  [key: string]: {
    labelMin: string
    labelMax: string
  }
}

type ValidationsProps = {
  questionKind?: string
  formMethods: UseFormReturn<CustomFormQuestion>
}

export default function MinimunAnxMaximunValidators({ formMethods, questionKind }: ValidationsProps) {
  const inputsLabel = useMemo(() => {
    const labels: KeyString = {
      INTEGER: {
        labelMin: 'Número mínimo',
        labelMax: 'Número máximo',
      },
      DECIMAL: {
        labelMin: 'Número mínimo',
        labelMax: 'Número máximo',
      },
      SINGLE_FILE_UPLOAD: {
        labelMin: 'Tamanho mínimo (Bytes)',
        labelMax: 'Tamanho máximo (Bytes)',
      },
      MULTIPLE_FILE_UPLOAD: {
        labelMin: 'Tamanho mínimo (Bytes)',
        labelMax: 'Tamanho máximo (Bytes)',
      },
      MULTIPLE_SELECTION_BOX: {
        labelMin: 'Número mínimo',
        labelMax: 'Número máximo',
      },
    }

    const defaultValue = {
      labelMin: 'Número mínimo',
      labelMax: 'Número máximo',
    }

    return labels[questionKind as string] || defaultValue
  }, [questionKind])

  const minSize = formMethods.watch('validation.min')
  const maxSize = formMethods.watch('validation.max')

  const isFileUpload = useMemo(() => {
    return ['MULTIPLE_FILE_UPLOAD', 'SINGLE_FILE_UPLOAD'].includes(questionKind as string)
  }, [])

  return (
    <Stack>
      <FormControl display="flex" flexDir="column" gap={2}>
        <FormLabel fontWeight="bold">{inputsLabel.labelMin}</FormLabel>
        <Controller
          name="validation.min"
          control={formMethods.control}
          render={({ field }) => (
            <NumberInput
              {...field}
              value={field.value ?? 0}
              onChange={(valueString) => field.onChange(Number(valueString))}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          )}
        />
      </FormControl>

      {isFileUpload && (
        <HStack>
          <Text>Tamanho mínimo</Text>
          <Text color="primary">{convertBytesNumberToString(minSize)}</Text>
        </HStack>
      )}

      <FormControl display="flex" flexDir="column" gap={2}>
        <FormLabel fontWeight="bold">{inputsLabel.labelMax}</FormLabel>
        <Controller
          name="validation.max"
          control={formMethods.control}
          render={({ field }) => (
            <NumberInput
              {...field}
              value={field.value ?? 0}
              onChange={(valueString) => field.onChange(Number(valueString))}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          )}
        />
      </FormControl>

      {isFileUpload && (
        <HStack>
          <Text>Tamanho máximo</Text>
          <Text color="primary">{convertBytesNumberToString(maxSize)}</Text>
        </HStack>
      )}
    </Stack>
  )
}
